import LP_api from 'react-sdk/LP_api'
import AppState from './AppState'

class ReaxeAPI {
  api = null

  #moduleCallbacks = new Map()

  constructor() {

    this.api = new LP_api()
    // window.LP_API = lp_api


    this.api.onCallfunction = (name, data) => {
      // console.info("LPAPI : function called from game : ", name, "(", data, ")")

      // la Map est prête
      if(name === "signalGameReady" ) {
        // on lance l'affichage de la map
        AppState.onBackendReady();
        this.api.registeredFunctions.startGame(false)


      }

      if(name === "haxeToReact" ) {
        let {module, event, params} = data.data

        if (module) {
          let cb = this.#moduleCallbacks.get(module);
          if (cb) {
            cb(event, params, data.done);
            return;
          }
        }
        // on arrive ici si y'a pas de module indiqué ou pas de module correspond, dans ce cas on appelle le callback directement
        if (data.done)
          data.done()
      }
    }

  }

  /**
   *
   * @param {String} module
   * @param {(event : String, params)} cb
   */
  registerModule(module, cb) {
    this.#moduleCallbacks.set(module, cb)
  }

  toHaxe(module, event, params = null, cb = null) {
    return new Promise((resolve) => {
      this.api.registeredFunctions.reactToHaxe({
        "module" : module,
        "event" : event,
        "params" : params
      }, resolve);
    } );
  }

}


export default ReaxeAPI
